import validation from './validation.js';

var checkboxInput = {

	/**
	 * Init
	 *
	 * @param {object} target
	 *
	 * @returns {void}
	 */
	init: function(target) {

		checkboxInput.initBoolInput(target);
		checkboxInput.initToggleInput(target);

	},

	/**
	 * Init
	 *
	 * @param {object} target
	 *
	 * @returns {void}
	 */
	initBoolInput: function(target) {

		var checkboxes = target.querySelectorAll('input[type=checkbox][data-checkbox-text]');
		for (var i = 0; i < (checkboxes.length); i++) {
			checkboxes[i].addEventListener('change', function(e) {
				var n = e.target.nextElementSibling;
				if ((n.nodeName == 'INPUT') && (n.hasAttribute('data-checkbox-text-input'))) {
					if (e.target.checked) {
						n.value = true;
					} else {
						n.value = false;
					}
				}
			});
		}

	},

	/**
	 * Init
	 *
	 * @param {object} target
	 *
	 * @returns {void}
	 */
	initToggleInput: function(target) {

		var checkboxes = target.querySelectorAll('input[type=checkbox][data-checkbox-toggle-input]');
		for (var i = 0; i < (checkboxes.length); i++) {
			checkboxes[i].addEventListener('change', function(e) {
				let inputs = e.target.parentElement.parentElement.querySelectorAll('[data-checkbox-toggle-input-target]');
				for (var a = 0; a < (inputs.length); a++) {
					if (!inputs[a].hasAttribute('data-initial-value')) {
						inputs[a].setAttribute('data-initial-value', inputs[a].value);
					}
					inputs[a].removeAttribute('disabled');
					validation.addRequired(inputs[a]);
					if (!e.target.checked) {
						validation.removeRequired(inputs[a]);
						inputs[a].value = inputs[a].getAttribute('data-initial-value') || '';
						inputs[a].setAttribute('disabled', true);
					}
				}
				if (inputs.length < 2) {
					inputs[(a - 1)].focus();
				}
			});
		}

	}

};

export default checkboxInput;
